module.exports = __webpack_public_path__ + "static/media/290797.17b7a57f.png";